export const OAUTH2_CLIENT_ID = 'web'
export const OAUTH2_CALLBACK_URL = '/web/api/auth/callback'
